import axios from 'axios'
import { useState } from 'react'
import { apiStatus } from '../constants/apiStatus'
import { apiUrl, axiosDefaultHeader, baseUrl, stage } from '../constants/apiUrl'
import { loadStatus } from '../constants/loadStatus'
import { errorMsg } from '../constants/messages'
import type { ResultDeviceInfo } from '../interfaces/DeviceIf'
import { useAuth } from './useAuth'

interface C213DeviceGetProps {
  execDeviceGet: (tenant: string) => Promise<ResultDeviceInfo>
  loading: loadStatus
}

// C213 テナント配下デバイス取得API呼出
export const useC213DeviceGet = (): C213DeviceGetProps => {
  const [loading, setLoading] = useState(loadStatus.NONE)
  const auth = useAuth()

  const execDeviceGet = async (tenant: string) => {
    try {
      setLoading(loadStatus.LOADING)
      const jwt = await auth.getJwt()
      if (jwt === '') {
        setLoading(loadStatus.LOADED)
        return { success: false, message: errorMsg.SESSION_ERROR }
      }

      const header = Object.assign(axiosDefaultHeader, {
        Authorization: 'Bearer ' + jwt,
      })

      const response = await axios.get(
        `${baseUrl}${stage}${apiUrl.tenantsPath}${tenant}${apiUrl.devicesPath}`,
        {
          headers: header,
          validateStatus: () => true,
        },
      )

      if (response.status === apiStatus.SUCCESS) {
        setLoading(loadStatus.LOADED)
        return { success: true, info: response.data }
      }

      setLoading(loadStatus.LOADED)
      if (response.data && response.data.message) {
        return { success: false, message: response.data.message }
      }
      return { success: false, message: errorMsg.SYSTEM_ERROR }
    } catch (error) {
      setLoading(loadStatus.LOADED)
      return { success: false, message: errorMsg.SYSTEM_ERROR }
    }
  }

  return { execDeviceGet, loading }
}
